import React from 'react';
import classNames from 'classnames';

const LogicOpButton = ({className, label, active, onClick}) => (
    <button className={classNames(className, 'logic-op-button btn', {active})} type="button" onClick={onClick}>
        {label}
    </button>
);

export default LogicOpButton;
